import React, { useEffect } from 'react';

import { Alert as MuiAlert, Grow, Slide, Typography } from '@mui/material';
import { Check, Close as CloseIcon } from '@mui/icons-material';

const Alert = ({ open, text = '', type = '', onDismiss, children, ...props }) => {
  // const content = children || (text ? <Typography variant="body2" sx={{ fontWeight: '500' }}>{text}</Typography> : text);
  
  return (
    <Grow in={open} direction="right">
      <MuiAlert
        severity={type}
        iconMapping={{
          success: <Check sx={{ fontSize: '16px' }} />,
        }}
        open={open}
        onClose={onDismiss}
        sx={{
          mb: 1,
          position: 'absolute',
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          top: 0,
          right: 16,
          py: 1.5,
          left: 16,
          maxWidth: 'calc(100% - 32px)',
          width: 'calc(100% - 32px)',
          '& .hotglue-w-MuiAlert-action': {
            p: '2px 0 0 16px',
            '& .hotglue-w-MuiSvgIcon-root': {
              fontSize: '16px',
            },
          },
          '& .hotglue-w-MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            py: 0.5,
            minWidth: 0,
            overflow: 'hidden',
          },
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: '500',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {text}
        </Typography> 
      </MuiAlert>
    </Grow>
  );
};

export default Alert;
